var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrangeExclamationMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.06289 2.00195C3.98289 2.00195 1.46289 4.52195 1.46289 7.60195C1.46289 10.682 3.98289 13.202 7.06289 13.202C10.1429 13.202 12.6629 10.682 12.6629 7.60195C12.6629 4.52195 10.1429 2.00195 7.06289 2.00195Z",
    fill: "#FF9500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.64203 8.72195H7.55203C7.76203 8.72195 7.90203 8.58195 7.90203 8.37195L8.04203 4.10195C8.04203 3.89195 7.90203 3.75195 7.69203 3.75195H6.43203C6.22203 3.75195 6.08203 3.89195 6.08203 4.10195L6.22203 8.37195C6.29203 8.58195 6.43203 8.72195 6.64203 8.72195Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06203 9.49195C6.50203 9.49195 6.08203 9.91195 6.08203 10.472C6.08203 11.032 6.50203 11.452 7.06203 11.452C7.55203 11.452 8.04203 11.032 8.04203 10.472C8.04203 9.91195 7.55203 9.49195 7.06203 9.49195Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeExclamationMark);
export default __webpack_public_path__ + "static/media/orange-exclamation-mark.f50b2c61112f1edc5f74f62f001f3d38.svg";
export { ForwardRef as ReactComponent };